export enum ModalPositions {
  RIGHT = 'right',
  CENTER = 'center',
}
